// Firebase Analytics for the web app, using the same events as the iOS app so both show up together on
// the Firebase dashboard (Analytics → Events, filter by platform to split them).
//
// What the iOS app sends:
//   • `select_content` { item_id: 'id-appOpened', item_name: 'appOpened', content_type: 'cont' } each time it opens
//     (HomeViewController.analytics("appOpened")), and
//   • Firebase's automatic events: first_open/first_visit, session_start, user_engagement and screen_view
//     (named after the view controller).
// The web SDK collects the automatic session events itself; this file adds the `appOpened` event and sends
// `screen_view` with the matching iOS screen names, so a screen reads the same on both platforms.
import firebase from './firebase';

// The iOS view controllers these pages correspond to.
export const SCREENS = {
  home: 'HomeViewController',
  album: 'AlbumViewController',
  profile: 'ProfileViewController',
  band: 'BandViewController',
  shared: 'PublicShare',        // the public /a and /s pages: web only, no iOS counterpart
};

let analytics = null;
let started = false;
let lastScreen = null;

const get = () => {
  if (analytics) return analytics;
  if (started) return null;
  started = true;
  try {
    analytics = firebase.analytics();
    // Local development and tests shouldn't count as real usage.
    if (/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) analytics.setAnalyticsCollectionEnabled(false);
  } catch (e) {
    analytics = null; // blocked, unsupported browser, or no measurement ID: analytics just stays off
  }
  return analytics;
};

const log = (name, params) => {
  const a = get();
  if (!a) return;
  try { a.logEvent(name, params); } catch (e) { /* never let analytics break the app */ }
};

// Same event and parameters as the iOS app's analytics("appOpened").
export const trackAppOpened = () => log('select_content', {
  item_id: 'id-appOpened',
  item_name: 'appOpened',
  content_type: 'cont',
});

// A screen was shown. Repeats of the same screen in a row are ignored.
export const trackScreen = (screen) => {
  if (!screen || screen === lastScreen) return;
  lastScreen = screen;
  log('screen_view', { firebase_screen: screen, firebase_screen_class: screen });
};

// Start collecting right away so the automatic events (session start, page view, engagement) begin.
get();
